/* eslint-disable no-useless-escape */
import { createIntl, createIntlCache } from 'react-intl';
import moment from 'moment';
import url from 'url';
import myLocalStorage from './LocalStorage';

import TimeAgo from 'javascript-time-ago';
import vi from 'javascript-time-ago/locale/vi';
import en from 'javascript-time-ago/locale/en';

TimeAgo.addLocale(vi);
TimeAgo.addLocale(en);

const endPoint = process.env.API_URL;
export function formatDate(date, dateFormat, noTime) {
  return date && moment(date).isValid()
    ? moment(date).format(`${dateFormat} ${noTime ? '' : 'HH:mm:ss'}`)
    : '';
}

export function hasAdminRole(roleName) {
  const userInfo = myLocalStorage.getUserInfo();
  const rolePermission = myLocalStorage.getUserRole();
  if (userInfo.user.tenant_type === window.constant.TENANT_TYPE.ADMIN) {
    if (
      roleName === undefined ||
      (rolePermission.permissions &&
        rolePermission.permissions.includes(roleName))
    ) {
      return true;
    }
  } else {
    return false;
  }
}

export function hasRole(roleName) {
  const rolePermission = myLocalStorage.getUserRole();
  if (
    roleName === undefined ||
    (rolePermission.permissions &&
      rolePermission.permissions.includes(roleName))
  ) {
    return true;
  }
  return false;
}

export function formatDateTimeAgo(respone_time, dateString, dateFormat) {
  const timeAgo = new TimeAgo(localStorage.getItem('language') || 'vi');
  if (!moment(dateString).isValid()) {
    return dateString;
  }
  if (!respone_time) return moment(dateString).format(`${dateFormat}`);
  else {
    const ms = moment(respone_time).diff(moment.utc(dateString));
    const d = moment.duration(ms);
    if (d.asDays() > 5) {
      return moment(dateString).format(`${dateFormat}`);
    } else {
      return timeAgo.format(respone_time - ms);
    }
  }
}

/**
 * format number
 * @param {*} num
 */
export function addThousandSeparator(num) {
  num = Number(num);
  if (!num || num === 0) {
    return 0;
  } else {
    return num.toLocaleString('vi');
  }
}

/**
 * format number
 * @param {*} num
 */
export function divisionFormat(num1, num2) {
  if (!num2 || `${num2}` === '0') {
    return '-';
  } else if (num1 && num1 >= 0) {
    const value = num1 / num2;
    return addThousandSeparator(value);
  } else {
    return 0;
  }
}

/**
 * format number
 * @param {*} num
 */
export function formatNumberRate(num1, num2) {
  if (!num2 || `${num2}` === '0') {
    return '-';
  } else if (num1 && num1 >= 0) {
    const rate = ((num1 / num2) * 100).toFixed(
      window.constant.CURRENCY_DECIMAL
    );
    if (rate === '0.00') {
      return '-';
    } else {
      return `${rate}%`;
    }
  } else {
    return '-';
  }
}
/**
 * format number
 * @param {*} num
 */
export function formatNumberProgress(num1, num2) {
  if (!num2 || `${num2}` === '0') {
    return 0;
  } else if (num1 && num1 >= 0) {
    const rate = ((num1 / num2) * 100).toFixed(
      window.constant.CURRENCY_DECIMAL
    );
    return Number(rate);
  } else {
    return 0;
  }
}
/**
 * format number
 * @param {*} num
 */
export function addThousandSeparatorZeroAlias(num) {
  num = Number(num);
  if (!num || num === 0) {
    return '_';
  } else {
    return num.toLocaleString('vi');
  }
}
/**
 * Get message from multi language
 * @param {*} key
 */
const cache = createIntlCache();

export function getMessage(key, values = {}) {
  // const { intl } = new IntlProvider(
  //   { locale: window.lang, messages: window.messages },
  //   {}
  // ).getChildContext();
  const intl = createIntl(
    { locale: window.lang, messages: window.messages },
    cache
  );
  const message = intl.formatMessage({ id: key || '-' }, values);
  return message;
}

/**
 * show total item in table list
 * @param {*} num
 */
export function showTotalInfo(total, range) {
  return `${getMessage('common.table.paging.page')} ${range[0]} - ${
    range[1]
  }/${total} ${getMessage('common.table.paging.record')}`;
}

export function isAccess(item, pathname) {
  // return pathname.startsWith(item);
  return pathname === item;
}

export function buildQueryParams(filters) {
  const filterParams = [];
  for (const key in filters) {
    if (key) {
      // if (typeof filters[key] === 'string') {
      //   filterParams.push(`filters[${key}]=${filters[key]}`);
      //   continue;
      // }
      const item = filters[key];
      let { val_1, val_2 } = item;
      const { field } = item;
      const { allow_push_empty } = item;
      const { type } = item;
      // neu co du lieu value 1 thi moi push len
      if (typeof val_1 !== 'undefined') {
        if (Array.isArray(val_1)) {
          val_1 = val_1.join();
        }
        if (Array.isArray(val_2)) {
          val_2 = val_2.join();
        }
        if (type === 'date') {
          val_1 = val_1 ? val_1.format(window.constant.API_DATE_FORMAT) : null;
          val_2 = val_2 ? val_2.format(window.constant.API_DATE_FORMAT) : null;
        }
        if (typeof val_1 === 'string') {
          val_1 = val_1.trim();
        }
        if (!allow_push_empty) {
          if (val_1.toString().length > 0) {
            filterParams.push(
              `filters[${key}][oper]=${item.oper}&filters[${key}][val_1]=${val_1}&filters[${key}][field]=${field}&filters[${key}][val_2]=${val_2}&filters[${key}][type]=${type}`
            );
          }
        } else {
          filterParams.push(
            `filters[${key}][oper]=${item.oper}&filters[${key}][val_1]=${val_1}&filters[${key}][val_2]=${val_2}&filters[${key}][type]=${type}`
          );
        }
      }
    }
  }
  return filterParams.join('&');
}
// chuyển tiếng việt thành ko dấu
export function change_alias(alias) {
  let str = alias;
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(
    // eslint-disable-next-line
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    ' '
  );
  str = str.replace(/ + /g, ' ');
  str = str.trim();
  return str;
}

// endPoint should https://domain.com/one/    (should be endwith splash character ('/'))
/* eslint-disable-next-line max-len */
export const makeOriginImageUrl = (image_url) =>
  url.resolve(`${endPoint}/`, String(image_url));

export const transformKey = (arrayBy = [], f1 = 'id', f2 = 'text') =>
  arrayBy.reduce((total, current) => {
    // eslint-disable-next-line eqeqeq
    if (current[f2] == 0) {
      total[current[f1]] = 0;
    } else {
      total[current[f1]] = current[f2] || current.text;
    }
    return total;
  }, {});

export const validatePercent = (rule, value) => {
  if (!value) return Promise.resolve();
  if (!Number(value)) {
    return Promise.reject(new Error('Vui lòng nhập số'));
  } else if (Number(value) > 100 || Number(value) < 0) {
    return Promise.reject(new Error('Vui lòng nhập lại'));
  } else {
    return Promise.resolve();
  }
};

export const validateNumber = (rule, value) => {
  if (!value) return Promise.resolve();
  if (!Number(value) && Number(value) !== 0) {
    return Promise.reject(new Error('Vui lòng nhập số'));
  } else if (Number(value) < 0) {
    return Promise.reject(new Error('Vui lòng nhập lại'));
  } else {
    return Promise.resolve();
  }
};

// export function getRandomInt(min, max) {
//   min = Math.ceil(min);
//   max = Math.floor(max);
//   return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
// }

export const currencyFormat = (value) =>
  value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
